export enum AdminShiftCanceledBecause {
  CANCEL_BY_WORKER = 1,
  WORKER_DID_NOT_COME = 2,
  INSTITUTION_DEMAND = 3,
  NO_APPLY_IN_TIME = 4,
  ACTIVITY_REDUCTION = 5,
  WORKER_FIND_OUT_OF_NETWORK = 6,
  INSTITUTION_INTERIM = 7,
  INSTITUTION_NO_WORKER_NEEDED = 8,
  INSTITUTION_TYPING_ERROR = 9,
  NB_HOUR_FOR_WORKER_OVER_COME = 10,
  INSTITUTION_OTHER_REASON = 11,
  FIND_OUT_OF_HUBLO = 12,
  INTERNAL_ORGANISATION = 13,
}
